var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.036,
    y: 0.036,
    width: 39.929,
    height: 39.929,
    rx: 19.964,
    fill: "#FF595A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.009 15.009l9.982 9.982M15.009 24.991l9.982-9.982",
    stroke: "#fff",
    strokeWidth: 2.655,
    strokeLinecap: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC4wMzU2NDQ1IiB5PSIwLjAzNTcwNTYiIHdpZHRoPSIzOS45Mjg2IiBoZWlnaHQ9IjM5LjkyODYiIHJ4PSIxOS45NjQzIiBmaWxsPSIjRkY1OTVBIi8+CjxwYXRoIGQ9Ik0xNS4wMDg4IDE1LjAwODlMMjQuOTkwOSAyNC45OTExIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIuNjU1MjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTUuMDA4OCAyNC45OTFMMjQuOTkwOSAxNS4wMDg5IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIuNjU1MjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgRedX as ReactComponent };